import React, {
    useEffect,
    useRef,
    useState
} from "react";
import {
    Form,
    useNavigate
} from 'react-router-dom';
import Ajax from "../inc/js/Ajax";
import {
    HelmetWrapper
} from "../inc/js/Helper"
import {
    PlusCircle_8_Blue,
    Trash_8_Red
} from "../inc/images/svgs";
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    Divider,
    Input,
    RadioGroup,
    Radio,
    Spacer,
    Switch,
    Textarea
} from "@nextui-org/react";
import swal from "sweetalert2";

export default function AddOptions({clientInformation}) {  
    const navigate = useNavigate();
    const [formDetails, setFormDetails] = useState({});
    const [formDetailUpdates, setFormDetailUpdates] = useState({});    
    const [formData, setFormData] = useState([]);
    const [formName, setFormName] = useState();
    const [isBasicForm, setIsBasicForm] = useState(true);
    
    const [formChanges, setFormChanges] = useState([]);
    const [formUpdated, setFormUpdated] = useState(false);
    
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

    useEffect(() => {
        if (clientInformation.userInformation.loggedIn === false) {
            navigate("/Login");
        } else {
            const queryParams = new URLSearchParams(window.location.search);
            const param = queryParams.get("form") || localStorage.getItem("form");
            
            if (!param) {
                swal.fire({
                    title: "Whoopsie Daisy",
                    text: "Missing Advanced Form Id, please try again.",
                    icon: "error",
                    didClose:(() => {
                        navigate("/Forms");
                    })
                })
            } else {
                if (window.history.replaceState) {
                    localStorage.setItem("form", param);
                    window.history.replaceState(null, null, window.location.pathname);
                }

                Ajax.request({
                    url:"/JudgeAutos/readForm",
                    jsonData: {
                        form: "advancedforms",
                        formId: param
                    },
                    success:function(reply) {
                        setFormDetails(reply.data.formDetails);
                        setFormName(reply.data.formDetails.formName);
                        setIsBasicForm(reply.data.formDetails.type !== "custom");

                        setFormData(() => (
                            reply.data.formData.map(item => ({
                                ...item,
                                settings: JSON.parse(item.settings)
                            }))
                        ));
                    }
                });
            }
        }
    }, [clientInformation]);

    useEffect(() => {
        const handleResize = () => {
            const newWidth = window.innerWidth;
            const isNowMobile = newWidth < 640;
    
            if (Math.abs(newWidth - screenWidth) > 100) {
                setScreenWidth(newWidth);
                setIsMobile(isNowMobile);
            }
        };
    
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [screenWidth]);

    const updateForm = () => {
        return new Promise((resolve, reject) => {
            const preppedInfoUpdates = Object.keys(formDetailUpdates).length > 0 && [{
                formName: formDetailUpdates.formName || formDetails.formName,
                formDescription: formDetailUpdates.formDescription || formDetails.formDescription
            }]
    
            Ajax.request({
                url:"/JudgeAutos/updateOptionsForm",
                jsonData: {
                    advancedFormId: formDetails["advancedFormId"],
                    settings: JSON.stringify(formData[0].settings),
                    formInfoUpdates: preppedInfoUpdates
                },
                success: function(reply) {
                    swal.fire({
                        title: `${reply.data}`,
                        text: `Changes saved to ${formName}`,
                        icon: "success",
                        timer: 3000,
                        didClose: () => {
                            window.location.href = `/AddOptions?form=${formDetails["advancedFormId"]}`;
                        }
                    });
                    resolve(reply);
                },
                error: function(error) {
                    reject(error);
                }
            });
        });
    }

    const handleFormInfoUpdates = (key, value) => {
        setFormUpdated(true);

        setFormDetails((prev) => ({
            ...prev,
            [key]: value
        }));

        setFormDetailUpdates((prev) => ({
            ...prev,
            [key]: value
        }));
    }

    const handleSettingChange = (rowIndex, topic, field, value) => {
        setFormData(prev => {
            const copy = [...prev];

            copy[rowIndex] = {
                ...copy[rowIndex],
                settings: {
                    ...copy[rowIndex].settings,
                    [topic]: {
                        ...copy[rowIndex].settings[topic],
                        [field]: value
                    }
                }
            };
            return copy;
        });

        setFormChanges(prev => ({
            ...prev,
            [rowIndex]: {
                ...(prev[rowIndex] || {}),
                settings: {
                    ...(prev[rowIndex]?.settings || {}),
                    [topic]: {
                        ...(prev[rowIndex]?.settings?.[topic] || {}),
                        [field]: value
                    }
                }
            }
        }));

        setFormUpdated(true);
    };

    return(
        <>
            <HelmetWrapper
                title="JudgeAutos - Advanced Form"
                description="Manage advanced options for your car, truck, and bike shows with JudgeAutos for efficient scoring and event management."
                url="AdvancedForm"
            />
    
            <div className="flex-col mx-auto sm:w-2/3">
                {formDetails && (
                    <div>
                        <h1 className="text-3xl text-center">{formName}</h1>
                    </div>
                )}
                <Spacer y={10} />
                {formDetails && (
                    <div>
                        <div className="text-center">
                            <Form className="grid grid-cols-2 gap-2 place-content-center">
                                <Input
                                    isReadOnly={isBasicForm}
                                    key="formName"
                                    id="formName"
                                    label="Name"
                                    value={formDetails.formName}
                                    onChange={(e) => handleFormInfoUpdates(e.target.id, e.target.value)}
                                    variant="bordered"
                                    classNames={{input: "text-[16px]"}}
                                />
                                <Input
                                    isReadOnly={isBasicForm}
                                    key="formDescription"
                                    id="formDescription"
                                    label="Description"
                                    value={formDetails.formDescription}
                                    onChange={(e) => handleFormInfoUpdates(e.target.id, e.target.value)}
                                    variant="bordered"
                                    classNames={{input: "text-[16px]"}}
                                />
                                <Input
                                    isReadOnly
                                    key="formType"
                                    id="formType"
                                    label="Type"
                                    value={`${formDetails.type ? formDetails.type.charAt(0).toUpperCase() + formDetails.type.slice(1) : ''} Judge Form`}
                                    variant="flat"
                                    classNames={{input: "text-[16px]"}}
                                />
                                <Input
                                    isReadOnly
                                    key="dateCreated"
                                    id="dateCreated"
                                    label="Date Created"
                                    value={new Date(formDetails.dateCreated).toLocaleDateString("en-US")}
                                    variant="flat"
                                    classNames={{input: "text-[16px]"}}
                                />
                            </Form>
                        </div>
                        <Spacer y={3} />
                        <div className="text-center">
                            <Button
                                className={isBasicForm && "hidden"}
                                onPress={() => {
                                    if (formUpdated) {
                                        updateForm();
                                    } else {
                                        swal.fire({
                                            title: "No changes made",
                                            text: "Please make your changes before saving",
                                            icon: "error",
                                            timer: 1500
                                        })
                                    }
                                }}
                                color="primary"
                            >
                                Save
                            </Button>
                        </div>
                    </div>
                )}
                <Spacer y={5} />
                <Divider />
                <Spacer y={5} />
                {formData?.map(form =>
                    Object.entries(form.settings).map(([topic, config], index) => (
                        <Card
                            key={`${form.advancedFormDataId}-${topic}`}
                            className="flex flex-col h-full"
                        >
                            <CardHeader className="justify-center">
                                <h3 className="text-3xl capitalize">
                                    {topic.replace("_", " ")}
                                </h3>
                            </CardHeader>
                            <CardBody className="flex-1 text-lg">
                                <Textarea
                                    isReadOnly
                                    variant="bordered"
                                    classNames={{input: "text-[16px]"}}
                                    value={config.description}
                                />
                                <Spacer y={3} />
                                <div className="grid grid-cols-2 gap-2">
                                    {Object.entries(config).map(([key, value]) => {
                                        if (["selection", "description"].includes(key)) return null;

                                        const isEnabledField = key === "enabled";
                                        
                                        if (!isEnabledField && !config.enabled) return null;

                                        return (
                                            <div key={key} className="space-y-2">
                                                {isEnabledField && (
                                                    <span className="font-semibold capitalize">
                                                        {key.replace("_", " ")}
                                                    </span>
                                                )}

                                                {!isEnabledField && config.enabled && (
                                                    <span className="font-semibold capitalize">
                                                        {key.replace("_", " ")}
                                                    </span>
                                                )}
                                                
                                                {isEnabledField && (
                                                    <>
                                                        <Spacer y={2} />
                                                        <Switch
                                                            isReadOnly={isBasicForm}
                                                            isSelected={config.enabled}
                                                            onValueChange={(val) =>
                                                            handleSettingChange(index, topic, "enabled", val)
                                                            }
                                                        />
                                                    </>
                                                )}
                                                
                                                {!isEnabledField && config.enabled && (
                                                    <>
                                                        {Array.isArray(value) && (
                                                            <RadioGroup
                                                                value={String(config.selection)}
                                                                onValueChange={(val) =>
                                                                    handleSettingChange(index, topic, "selection", Number(val))
                                                                }
                                                            >
                                                                {value.map(v => (
                                                                    <Radio key={v} value={String(v)}>
                                                                        {v}
                                                                    </Radio>
                                                                ))}
                                                            </RadioGroup>
                                                        )}
                                                        
                                                        {typeof value === "boolean" && (
                                                            <>
                                                                <Spacer y={2} />
                                                                <Switch
                                                                    isSelected={value}
                                                                    onValueChange={(val) =>
                                                                    handleSettingChange(index, topic, key, val)
                                                                    }
                                                                />
                                                            </>
                                                        )}
                                                        
                                                        {typeof value !== "boolean" && !Array.isArray(value) && (
                                                            <p>{value}</p>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </CardBody>
                            <CardFooter className="justify-center">
                                {/* <Button size="md" color="primary">
                                    Edit
                                </Button> */}
                            </CardFooter>
                        </Card>
                    ))
                )}
                <Spacer y={4} />
                <Card className="flex flex-col h-full">
                    <CardHeader className="justify-center">
                        <h3 className="text-3xl capitalize">More Coming Soon!</h3>
                    </CardHeader>
                    <CardBody className="flex-1 text-lg flex items-center justify-center">
                        <Textarea
                            isReadOnly
                            variant="bordered"
                            classNames={{input: "text-[16px]"}}
                            value={
                                "Options such as judge locking, DJ support, vendor options, contestant notifications, event timing controls, and more will be added in future updates.\n\nLet us know what you're most excited for by submitting Feedback!"
                            }
                            className="text-center text-gray-500 text-xl"
                        />
                        <Spacer y={5} />
                        <Button
                            color="primary"
                            variant="solid"
                            size="lg"
                            onPress={() => {navigate("/ContactUs")}}
                        >
                            Submit Feedback
                        </Button>
                    </CardBody>
                    <CardFooter className="justify-center">
                        {/* Optional footer */}
                    </CardFooter>
                </Card>

                {/* <div className="text-center">
                    <Button
                        className={isBasicForm && "hidden"}
                        onPress={() => {
                            if (formUpdated) {
                                updateForm();
                            } else {
                                swal.fire({
                                    title: "No changes made",
                                    text: "Please make your changes before saving",
                                    icon: "error",
                                    timer: 1500
                                })
                            }
                        }}
                        color="primary"
                    >
                        Save
                    </Button>
                </div> */}
            </div>
        </>
    );
}